import * as types from "../actions/actionsTypes";

// Reducer named campaignsReducer
const initialState = {
    loaded:false,
    data: null
};

export default function campaignsReducer(state = initialState, action) {
    switch (action.type) {
        case types.LATEST_CAMPAIGNS:
            return {...state, loaded:true, data: action.payload};
        default:
            return state;
    }
};